<div *ngIf="!isLoading" class="auth-box-w wider centered">
  <div class="logo-w">
    <a href="index.html"><img alt="" src="./assets/logo.png"/></a>
    <app-lang-selector-backoffice></app-lang-selector-backoffice>
  </div>

  <div *ngIf="isEmailVerified; else emailNotVerified">
    <div *ngIf="!isUserBlocked; else userBlocked">
      <h5 class="auth-header">{{ 'SelectPage.ManageLocation' | translate }}</h5>
      <div class="client-list">
        <div class="item" *ngFor="let client of clients" (click)="openClientDashboard(client.id, client)">
          <div class="thumbnail">
            <img alt="" src="https://cdn.gastroguide.de/{{ client.logo }}" *ngIf="client.logo" />
            <img alt="" src="./assets/img/no-image.svg" *ngIf="!client.logo" />
          </div>
          <div class="logged-user-name">
            <strong>{{ client.name }}</strong
            ><br />
            <span class="address">{{ client.street }}, {{ client.zipCode }} {{ client.location }} </span>
          </div>
          <div class="auth-type">
            {{ client.isModerator ? 'Moderator' : 'Administrator' }}
          </div>
        </div>
      </div>
      <button class="btn btn-primary" (click)="addNewClient()">{{ 'SelectPage.AddNewCompany' | translate }}</button>
    </div>
  </div>
  <ng-template #emailNotVerified>
    <div *ngIf="userEmail">
      <h6 class="auth-header p-2">
        {{ 'SelectPage.VerifyEmailMessage' | translate }}: {{ userEmail }}
        <button *ngIf="!lastAttempt" class="btn edit-btn" (click)="editEmail()" matTooltip="Bearbeiten">
          <i class="fas fa-edit"></i>
        </button>
      </h6>

      <div class="text-center p-2">
        <button class="btn btn-secondary" [disabled]="isButtonDisabled" (click)="resendVerificationEMail()">
          Resend Email
        </button>
        <div class="text-danger" *ngIf="isButtonDisabled">
          Try again in {{ remainingSeconds }} second{{ remainingSeconds > 1 ? 's' : '' }}...
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #userBlocked>
    <h6 class="auth-header">
      <div [innerHtml]="'SelectPage.newUserContactAdmin' | translate"></div>
    </h6>
  </ng-template>
</div>
